import regionReducer from './reducers';

export const { setRegion } = regionReducer.actions;
